export default "__VITE_ASSET__HOsrvqC7__"